import { Routes, Route, Navigate } from 'react-router-dom';

import DocsContent from './DocsContent/DocsContent';
import AnalyticsContent from './AnalyticsContent';

export default function AnalyticsWasteCadastrePage() {
  return (
    <Routes>
      <Route path="electronic_document" element={<DocsContent />} />
      <Route path="cadastral_analytics" element={<AnalyticsContent />} />

      <Route path="*" element={<Navigate to="electronic_document" replace />} />
    </Routes>
  );
}
